import { combineReducers } from 'redux';
import { GET_PRICING_SCENARIO_REPORT } from './pricing-config-qa-report.types';

export const STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const initialState = {
  contentId: '',
  fileName: '',
};

export const report = (state = initialState, action = {}) => {
  switch (action?.type) {
    case GET_PRICING_SCENARIO_REPORT.STARTED:
      return {
        ...state,
        contentId: '',
        fileName: '',
      };
    case GET_PRICING_SCENARIO_REPORT.SUCCEEDED:
      return {
        ...state,
        contentId: action?.payload?.info?.report?.report_files[0]?.content_id,
        fileName: action?.payload?.info?.report?.report_files[0]?.filename,
      };
    default:
      return state;
  }
};

export const requestStatus = (state = STATUS.IDLE, action = {}) => {
  switch (action?.type) {
    case GET_PRICING_SCENARIO_REPORT.STARTED:
      return STATUS.LOADING;
    case GET_PRICING_SCENARIO_REPORT.SUCCEEDED:
      return STATUS.SUCCESS;
    case GET_PRICING_SCENARIO_REPORT.ERRORED:
      return STATUS.ERROR;
    default:
      return state;
  }
};

export const employerPricingScenarioReportReducer = combineReducers({
  report,
  requestStatus,
});
